module.exports = __webpack_public_path__ + "static/media/red-blue.278360df.jpg";